import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "ta-e" };
const _hoisted_2 = { class: "ta-e" };
const _hoisted_3 = { class: "ta-c" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_btn = _resolveComponent("v-btn");
    return (_openBlock(), _createElementBlock("tr", null, [
        _createCommentVNode(" 패널티 적용 시작 건수 "),
        _createElementVNode("td", _hoisted_1, _toDisplayString(_ctx.$t(`${_ctx.lc}count`, { count: _ctx.penaltyStartCount })), 1 /* TEXT */),
        _createCommentVNode(" 배차취소 패널티 금액 "),
        _createElementVNode("td", _hoisted_2, _toDisplayString(_ctx.penaltyAmount), 1 /* TEXT */),
        _createElementVNode("td", _hoisted_3, [
            _createCommentVNode(" 수정 "),
            _createVNode(_component_v_btn, {
                icon: "mdi-pencil-outline",
                variant: "text",
                density: "comfortable",
                color: "black",
                onClick: _withModifiers(_ctx.handleClickEditDialogBtn, ["stop"])
            }, null, 8 /* PROPS */, ["onClick"])
        ])
    ]));
}
